var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClaimRowRejected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon / Claim (Rejected)") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Claim-(Rejected)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4,4 L16,4 C16.5522847,4 17,4.44771525 17,5 L17,19 C17,19.5522847 16.5522847,20 16,20 L4,20 C3.44771525,20 3,19.5522847 3,19 L3,5 C3,4.44771525 3.44771525,4 4,4 Z M5,7 L5,8 L10,8 L10,7 L5,7 Z M5,12 L5,13 L15,13 L15,12 L5,12 Z M5,14 L5,15 L14,15 L14,14 L5,14 Z M5,16 L5,17 L10,17 L10,16 L5,16 Z",
    id: "Claim",
    fill: "#FF7E5E"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#FF6640",
    cx: 17,
    cy: 7,
    r: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8368359,6.99794608 L19.8206157,8.97703603 C20.0597948,9.22090493 20.0597948,9.57732871 19.8206157,9.81650783 C19.5767468,10.0603767 19.2250128,10.0603767 18.9811439,9.82119762 L17.0020539,7.83741789 L15.022964,9.82119762 C14.7790951,10.0603767 14.4226713,10.0603767 14.1834922,9.81650783 C13.9396233,9.57732871 13.9396233,9.22090493 14.1788024,8.97703603 L16.1625821,6.99794608 L14.1788024,5.01885614 C13.9396233,4.77498724 13.9396233,4.42325324 14.1834922,4.17938434 C14.4226713,3.94020522 14.7790951,3.94020522 15.022964,4.17938434 L17.0020539,6.16316407 L18.9811439,4.17938434 C19.2250128,3.94020522 19.5767468,3.94020522 19.8206157,4.17938434 C20.0597948,4.42325324 20.0597948,4.77498724 19.8206157,5.01885614 L17.8368359,6.99794608 Z",
    id: "d",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimRowRejected);
export default __webpack_public_path__ + "static/media/claim-row-rejected.5ad381bf9d9be1bc9dccb702c3d5f3e6.svg";
export { ForwardRef as ReactComponent };